
import {ProgressBar} from "./progressBar";
function CheckpointItem({ checkpoint, onClick }) {
  return (
    <div
      className="profile-checkpoint-item"
      onClick={() => onClick(checkpoint.id)}
    >
      <img
        src={checkpoint.image}
        alt={checkpoint.name}
        className="profile-checkpoint-image"
      />
      <div className="profile-checkpoint-info">
        <div className="profile-checkpoint-name">{checkpoint.name}</div>
        <ProgressBar
           progress={checkpoint.progressPercentage} type="general" />

      </div>
      <div className="profile-checkpoint-percent">
        {checkpoint.progressPercentage}%
      </div>
    </div>
  );
}

export  {CheckpointItem};
